package fr.frux.feature.treedetail

import androidx.compose.runtime.Composable
import fr.frux.core.ads.AdHold
import fr.frux.core.ads.HoldAds
import fr.frux.feature.treedetail.identity.IdentitySheet

/**
 * Signalement, masquage et observation de terrain : aucune publicité pendant, ni juste après
 * (ADR 0030 point 2, #528). Les appels en vol comptent, pour couvrir aussi leur confirmation.
 * Extrait de [TreeDetailScreen] pour sa complexité cyclomatique (detekt).
 */
@Composable
internal fun TreeDetailSensitiveFlowHold(
    state: TreeDetailState,
    showReportUserSheet: Boolean,
    showBlockDialog: Boolean,
) {
    HoldAds(
        AdHold.SENSITIVE_FLOW,
        active =
            showReportUserSheet || showBlockDialog || state.isObservationPending ||
                state.isReportPending || state.isReportingPhoto || state.identity.sheet.isCorrectionSheet(),
    )
}

/** Les feuilles d'espèce et de note sont des corrections en cours, l'historique n'est qu'une lecture. */
private fun IdentitySheet?.isCorrectionSheet(): Boolean = this is IdentitySheet.Species || this is IdentitySheet.Note
